import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { partnerApi } from "../../../../../../../../../../services/Api/Partner/partnerApi";
import { PartnerDashboardApi } from "../../../../../../../../../../services/Api/Partner/partnerTypes";
import { selectPartner } from "../../../../../../../../../../services/partner/selectors";
import PartnerPayoutInvoiceForm from "./components/PartnerPayoutInvoiceForm";

const PartnerPreviewPayoutInvoicesNewPage = () => {
	const { t } = useTranslation("admin");
	const history = useHistory();
	const [dashboard, setDashboard] = useState<PartnerDashboardApi | undefined>(undefined);
	const partner = useSelector(selectPartner);
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${t("modules.payoff.header.preview.title")} | ${t("modules.partner.field.partner_panel.title")}`
		);
		fetchPartnerDashboard();
	}, []);

	const fetchPartnerDashboard = async () => {
		try {
			const res = await partnerApi.getPartnerDashboard(Number(partner?.id));
			setDashboard(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const goBack = () => {
		if (history.length > 1) history.goBack();
	};

	return (
		<>
			<Header title={t("modules.payoff.header.preview.title")} back={goBack} />
			<div className="content-preview">
				<p>{t("modules.payoff.header.preview.description")}</p>
				<h5>
					{dashboard?.balance ? (
						<>Do wypłaty: {FormatMoney(dashboard?.balance)}</>
					) : (
						<>Nie masz nic do wypłaty</>
					)}
				</h5>
				<hr />
				<h5>Dane do faktury:</h5>
				<p>
					<h6 className={"mb-2"}>Nabywca</h6>
					<p>
						GoPOS sp. z o.o.
						<br />
						ul. Rakowicka 43a/2
						<br />
						31-510 Kraków
						<br />
						NIP: 6772404663
						<br />
					</p>
					<h6 className={"mb-2"}>Elementy faktury:</h6>
					<p>
						Prowizja partnerska
						<br />
					</p>
				</p>
				<PartnerPayoutInvoiceForm balance={dashboard?.balance} />
			</div>
		</>
	);
};

export default PartnerPreviewPayoutInvoicesNewPage;
